import { RouteObject } from 'react-router-dom';
import { ATC_AVAILABLE } from '@/config/country';
import { BusinessCommerces } from '../BusinessCommerces';
import ShippingsRoutes from '../pages/Shippings/routes/ShippingsRoutes';
import SupportMaterialRoutes from '../pages/SupportMaterial/routes/SupportMaterialRoutes';
import JobsRoutes from '../pages/Jobs/routes/JobsRoutes';
import CasesRoutes from '../pages/Cases/routes/CasesRoutes';
import MeliAccessRoutes from '../pages/MeliAccess/routes/MeliAccessRoutes';

export const BusinessCommercesRoutes: RouteObject[] = [
  {
    path: '',
    element: <BusinessCommerces />,
  },
  ...ShippingsRoutes,
  ...SupportMaterialRoutes,
  ...JobsRoutes,
  ...(ATC_AVAILABLE ? CasesRoutes : []),
  ...MeliAccessRoutes,
];
